/**
 * LpTableHint
 * SPで横スクロールする表に、スワイプを促すヒントアイコンを重ねる。
 * 最初に横スクロールしたら消す。PCは表が収まるためヒント自体をCSSで非表示。
 * 本体サイトの TableHint と同じ仕組みだが、LPは本体のモジュールを参照しないため別に持つ。
 *
 * @example
 * <div class="p-lp-compare-table js-lp-table-hint">
 *   <div class="p-lp-compare-scroll js-lp-table-scroll"><table>…</table></div>
 *   <span class="p-lp-compare-hint"><img src="…ico_table_scroll.png" alt=""></span>
 * </div>
 */
export default class LpTableHint {
  constructor(wrap) {
    this.wrap = wrap;
    const scroller = wrap.querySelector('.js-lp-table-scroll');
    if (!scroller) return;

    scroller.addEventListener('scroll', () => wrap.classList.add('is-scrolled'), {
      once: true,
      passive: true,
    });
  }
}
